var _g, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyBoingoFiberSubhead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 874.98 100.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0,24.61h14.15l10.98,34.54,11.09-34.54h13.73l10.77,33.8,11.2-33.8h14.15l-17.96,52.81h-13.73l-11.3-36.12-11.41,36.12h-13.73L0,24.61Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.27,3.49h13.94v27.88c3.49-5.28,8.77-8.03,15.32-8.03,12.57,0,19.75,7.39,19.75,24.19v29.89h-13.94v-27.04c0-10.67-4.01-13.84-9.93-13.94-7.18-.11-11.2,4.54-11.2,13.31v27.67h-13.94V3.49Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.09,96.12l5.18-11.3c2.32,1.27,4.44,2.11,6.02,2.11,2.96,0,5.28-1.48,6.65-4.75l2.22-5.28-23.87-52.28h15.32l15,36.54,14.36-36.54h15.32l-23.98,57.35c-4.54,10.67-8.34,17.85-19.86,17.85-3.8,0-8.77-1.69-12.36-3.7Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.86,3.49h13.94v28.31c3.49-5.39,8.87-8.45,15.95-8.45,14.58,0,23.87,10.77,23.87,27.67s-9.29,27.67-23.87,27.67c-7.18,0-12.57-3.17-16.16-8.66l-.53,7.39h-13.2V3.49Zm39.29,47.53c-.11-8.66-5.39-14.79-12.89-14.79s-12.46,6.13-12.46,14.79,5.18,14.89,12.36,14.89,12.89-6.23,12.99-14.89Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.96,51.02c0-16.27,11.41-27.67,27.46-27.67s27.57,11.41,27.57,27.67-11.3,27.67-27.36,27.67-27.67-11.41-27.67-27.67Zm40.77,0c0-8.66-5.49-14.79-13.31-14.79s-13.2,6.13-13.2,14.79,5.49,14.79,13.41,14.79,13.1-6.13,13.1-14.79Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.97,8.03c0-4.33,3.7-8.03,8.03-8.03s8.03,3.7,8.03,8.03-3.7,8.03-8.03,8.03-8.03-3.7-8.03-8.03Zm1.06,16.58h13.94v52.81h-13.94V24.61Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.86,24.61h13.1l.63,7.08c3.49-5.39,8.87-8.34,15.53-8.34,12.57,0,19.75,7.39,19.65,24.19v29.89h-13.94v-27.04c0-10.67-3.91-13.84-9.82-13.94-7.29-.11-11.2,4.54-11.2,13.31v27.67h-13.94V24.61Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447,50.38c0-16.48,9.29-27.04,23.87-27.04,7.18,0,12.89,3.49,16.48,9.51v-8.24h13.94v47.11c0,17.96-10.56,28.2-27.67,28.2-12.15,0-19.75-2.96-23.66-5.81l5.49-11.2c2.96,1.69,8.66,4.65,17.53,4.65,8.34,0,14.36-4.75,14.36-15.42v-5.07c-3.59,5.6-9.29,8.87-16.48,8.87-14.58,0-23.87-10.03-23.87-25.56Zm39.82-.42c0-8.34-4.86-14.15-12.04-14.15s-12.57,5.81-12.67,14.15c.11,8.34,5.28,14.26,12.78,14.26s11.94-5.91,11.94-14.26Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.48,51.02c0-16.27,11.41-27.67,27.46-27.67s27.57,11.41,27.57,27.67-11.3,27.67-27.36,27.67-27.67-11.41-27.67-27.67Zm40.77,0c0-8.66-5.49-14.79-13.31-14.79s-13.2,6.13-13.2,14.79,5.49,14.79,13.41,14.79,13.1-6.13,13.1-14.79Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.12,35.81h-8.77v-11.2h8.77v-5.28c0-11.3,5.7-17.85,17.53-17.85,4.12,0,9.08,1.58,12.78,3.59l-5.18,10.03c-2.22-1.16-4.12-1.69-5.6-1.69-3.8,0-5.6,2.43-5.6,8.24v2.96h12.99v11.2h-12.99v41.62h-13.94v-41.62Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m641.13,8.03c0-4.33,3.7-8.03,8.03-8.03s8.03,3.7,8.03,8.03-3.7,8.03-8.03,8.03-8.03-3.7-8.03-8.03Zm1.06,16.58h13.94v52.81h-13.94V24.61Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m669.02,3.49h13.94v28.31c3.49-5.39,8.87-8.45,15.95-8.45,14.58,0,23.87,10.77,23.87,27.67s-9.29,27.67-23.87,27.67c-7.18,0-12.57-3.17-16.16-8.66l-.53,7.39h-13.2V3.49Zm39.29,47.53c-.11-8.66-5.39-14.79-12.89-14.79s-12.46,6.13-12.46,14.79,5.17,14.89,12.36,14.89,12.89-6.23,12.99-14.89Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m729.12,51.02c0-16.27,11.41-27.67,27.46-27.67,13.84,0,25.77,11.3,25.77,31.37h-38.66c.63,7.18,6.87,11.51,13.62,11.51,5.81,0,9.29-2.75,11.3-6.65l12.46,4.86c-4.54,8.98-12.78,14.26-25.24,14.26-15.63,0-26.72-11.41-26.72-27.67Zm15.31-6.65h22.81c-.63-6.65-6.55-9.19-11.09-9.19s-10.99,2.53-11.72,9.19Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m790.48,24.61h13.94v9.72c4.33-6.65,11.51-9.93,18.69-9.93v13.52c-9.72,0-18.69,3.49-18.69,11.72v27.78h-13.94V24.61Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m841.18,37.6l7.82-.53c7.39-.42,12.57-4.22,12.57-11.51,0-6.23-4.86-10.77-11.83-10.77-4.96,0-8.77,2.75-10.14,6.44l-12.67-3.59c2.75-9.29,11.09-15.42,22.81-15.42,14.79,0,25.24,9.72,25.24,23.34,0,11.41-7.92,19.22-19.75,20.7l-.21,9.93h-13.31l-.53-18.59Zm-1.27,32.85c0-4.65,3.7-8.45,8.45-8.45s8.45,3.8,8.45,8.45-3.8,8.55-8.45,8.55-8.45-3.8-8.45-8.55Z",
    fill: "#2c3037"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.57,
    y: 89.35,
    width: 137.58,
    height: 11.01,
    fill: "#35c0e2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 190.57,
    y: 89.35,
    width: 248.58,
    height: 11.01,
    fill: "#35c0e2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 507.69,
    y: 89.35,
    width: 366.58,
    height: 11.01,
    fill: "#35c0e2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyBoingoFiberSubhead);
export default __webpack_public_path__ + "static/media/why-boingo-fiber-subhead.c9b7ea9ed28500c7626840b66f9e9a29.svg";
export { ForwardRef as ReactComponent };